/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ApplicationErrorMessageFactory } from './application-error.message-factory';
import { ApplicationError } from '../model/application-error.model';
import { MessageFactoryProvider } from '../provider/message-factory.provider';

export class HttpErrorMessageFactory extends ApplicationErrorMessageFactory {

  getMessage(error: ApplicationError): string {
    if (error.arguments.error && error.arguments.status === 400) {
      const messageFactory = MessageFactoryProvider.resolveMessageFactory(error.arguments.error);
      if (messageFactory) {
        return messageFactory.getMessage(error.arguments.error);
      }
    }
    const messageArgs = super.getMessageArguments(error);
    return this.textService.getText(error.key, messageArgs);
  }

}
